import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { SaveOutlined, WarningOutlined } from "@ant-design/icons";
import { Button, Checkbox, Modal } from "antd";
import { Editor } from "grapesjs";
import { commonMedia } from "./grapesjs-config";

export const confirmMessage = (
  title: string,
  typePopup: number,
  content: string,
  ok?: any,
  cancel?: any,
  customFooter: boolean = false,
  customFooterFN?: any,
  customBodyFN?: any,
) => {
  Modal.confirm({
    title: title,
    icon: typePopup === 0 ? <WarningOutlined /> : <SaveOutlined />,
    content: customFooter ? (
      <>
        <Checkbox
          onChange={() => {
            customBodyFN && customBodyFN();
          }}
        >{t("Lưu làm mẫu", "Lưu làm mẫu")}</Checkbox>
        <br />
        <span className="description">{t("Khối giao diện sẽ được lưu vào mục Mẫu hoàn chỉnh", "Khối giao diện sẽ được lưu vào mục Mẫu hoàn chỉnh")}</span>
      </>
    ) : (
      content
    ),
    className: typePopup === 0 ? "modal-custom danger" : "modal-custom success",
    okButtonProps: {
      className: typePopup === 0 ? "btn btn-filled--danger" : "btn",
    },
    cancelButtonProps: {
      className: "btn btn-outlined",
    },
    okText: customFooter ? t("Lưu", "Lưu") : t("Xác nhận", "Xác nhận"),
    cancelText: t("Huỷ", "Huỷ"),
    onOk: () => {
      ok && ok();
    },
    onCancel: () => {
      cancel && cancel();
    },
    footer: (_, { OkBtn, CancelBtn }) => (
      <>
        <CancelBtn />
        {customFooter ? (
          <Button
            onClick={() => {
              customFooterFN && customFooterFN();
            }}
          >{t("Lưu nháp", "Lưu nháp")}</Button>
        ) : (
          ""
        )}
        <OkBtn />
      </>
    ),
  });
};

export const reloadAllTemplate = (editor: Editor, objTemplate: string) => {
  if (objTemplate) {
    const parseCourseSavedTempalte = JSON.parse(objTemplate);
    editor.setComponents(parseCourseSavedTempalte.html);
    editor.setStyle(parseCourseSavedTempalte.css);
  }
};

export const isValidJSON = (jsonString: string) => {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (error) {
    return false;
  }
};

export const checkTemplateIsNull = (editor: Editor) => {
  const components = editor.getComponents();
  if (components.length === 0) {
    return true;
  } else {
    return false;
  }
};

export const loadDefaultUI = (editor: Editor) => {
  // editor.setComponents(uiDefault.html);
  // editor.setStyle(uiDefault.css);
};

export const convertItemToBlock = (array: any[], item: any) => {
  if (item.options) {
    array.push({
      id: item.id,
      label: item.options.label,
      css: item.options.css,
      content: item.options.content,
      media: commonMedia,
      category: item.options.category,
    });
  } else {
    array.push({
      id: item.id,
      label: item.label,
      css: item.css,
      content: item.html ? item.html : item.content,
      media: commonMedia,
      category: item.category,
    });
  }
}

export const stringCssObj = (cssObj: any) => {
  let idStyleString = "";
  Object.entries(cssObj).forEach(([name, value]) => {
    idStyleString += `${name}:${value};`;
  });
  return idStyleString;
};

export const addBlockToEditor = (blockManager: any, blocks: any, cb?: any) => {
  blocks.forEach((b: any, i: number) => {
    blockManager.add(b.id, {
      label: b.label ? b.label : t('Mẫu ', 'Mẫu ') + (i + 1),
      content: b.html ? b.html : b.content,
      category: b.category,
      media: b.media,
    });
    if (i === blocks.length - 1) {
      cb && cb();
    }
  });
};